// extracted by mini-css-extract-plugin
export var footer = "_lp-5";
export var fulfillmentInput = "_lp-0";
export var shipDateInput = "_lp-1";
export var shipmentModal = "_lp-2";
export var shipmentModalContent = "_lp-3";
export var tableContainer = "_lp-4";